import axios from "axios"
import { SERVER_URI } from "../utils/config"

export const checkToken = async () => {
	const token = localStorage.getItem("adminToken")
	if (token) {
		axios.defaults.headers.common["Authorization"] = `Token ${token}`
		try {
			await axios.get(SERVER_URI + "/verify-token")
		} catch (e) {
			localStorage.removeItem("adminToken")
			axios.defaults.headers.common["Authorization"] = ""
		}
	}
}
